export default __webpack_public_path__ + "assets/images/11bfc294e1af89f94f5aecfbe9cf829b.png";